<template>
    <div class="panel">
        <div class="panel_head fx fx-m_between fx-c_start">
            <el-form :inline="true" :model="form">
                <el-form-item label="关键词">
                    <el-input v-model="form.keywords" placeholder="关键词"></el-input>
                </el-form-item>
                <el-form-item label="类型">
                    <el-select v-model="form.type" clearable placeholder="全部" style="width: 120px">
                        <el-option label="普通作品" :value="1"></el-option>
                        <el-option label="任务作品" :value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="编程语言">
                    <el-select v-model="form.lessonType" clearable placeholder="全部" style="width: 120px">
                        <el-option v-for="item in lessonTypes" :key="item.optionValue" :label="item.optionText"
                            :value="item.optionValue">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="状态">
                    <el-select v-model="form.state" clearable placeholder="全部" style="width: 120px">
                        <el-option label="未发布" :value="1"></el-option>
                        <el-option label="已发布" :value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="隐私">
                    <el-select v-model="isPrivate" clearable placeholder="全部" style="width: 120px">
                        <el-option label="公开" :value="false"></el-option>
                        <el-option label="不公开" :value="true"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="开源">
                    <el-select v-model="isOpenSource" clearable placeholder="全部" style="width: 120px">
                        <el-option label="开源" :value="true"></el-option>
                        <el-option label="不开源" :value="false"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        </div>
        <div class="panel_body">
            <el-table :data="tableData" stripe style="width: 100%">
                <el-table-column width="160" label="封面">
                    <template slot-scope="scope">
                        <el-image style="width: 150px; height: 90px" :src="scope.row.coverImg" :lazy="true"
                            :preview-src-list="[scope.row.coverImg]" fit="fill"></el-image>
                    </template>
                </el-table-column>
                <el-table-column min-width="180" prop="title" label="作品标题">
                </el-table-column>
                <el-table-column min-width="150" label="用户名/账号">
                    <template slot-scope="scope">
                        <div class="fx-col fx-center">
                            <span>{{scope.row.userName}}</span>
                            <span>{{scope.row.userSn}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column min-width="120" label="类型/语言">
                    <template slot-scope="scope">

                        <div class="fx-col fx-center">
                            <span>{{scope.row.typeName}}</span>
                            <span>{{scope.row.lessonTypeName}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="stateName" min-width="120" label="状态">
                </el-table-column>
                <el-table-column min-width="200" label="标签">
                    <template slot-scope="scope">
                        <tag-group :tags="scope.row.tagArray" size="mini"></tag-group>
                    </template>
                </el-table-column>
                <el-table-column min-width="120" label="浏览/点赞">
                    <template slot-scope="scope">
                        <div class="fx-col fx-center">
                            <span><i class="iconfont icon-yanjing text_primary"></i> {{scope.row.viewCount}}</span>
                            <span><i class="iconfont icon-dianzan text_warn"></i> {{scope.row.favorCount}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" min-width="150" label="创建时间">
                </el-table-column>
                <el-table-column min-width="120" label="权限">
                    <template slot-scope="scope">
                        <div class="fx-col fx-center">
                            <div class="fx-col fx-center">

                                <text-switch on-text="公开" off-text="不公开" :value="!scope.row.isPrivate"
                                    @change="modifyPrivate(scope.row)"></text-switch>
                                <text-switch on-text="开源" off-text="不开源" :value="scope.row.isOpenSource"
                                    style="margin-top: 10px" @change="modifyOpenSource(scope.row)"></text-switch>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" min-width="160" fixed="right">
                    <template slot-scope="scope">
                        <div class="fx fx-m_between fx-c_center">
                            <el-button type="primary" size="mini" @click="detail(scope.row)"><i
                                    class="iconfont icon-renwuxiangqing"></i> 详情页</el-button>
                            <el-link type="primary" @click="share(scope.row)" :underline="false"><i
                                    class="iconfont icon-fenxiang3"></i><b>分享</b></el-link>
                        </div>
                        <div class="fx fx-m_between fx-c_center" style="margin-top: 10px">
                            <el-button type="primary" size="mini" @click="view(scope.row)"><i
                                    class="iconfont icon-code "></i> 源代码</el-button>
                            <el-popconfirm @onConfirm="del(scope.row)" title="确认删除该作品吗？">
                                <el-link type="danger" slot="reference" :underline="false"><i
                                        class="iconfont icon-shanchu font20"></i><b>删除</b></el-link>
                            </el-popconfirm>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-dialog title="扫描下方二维码进行分享" :visible.sync="dialogTableVisible" center width="400px" style="margin-top: 1vh;"
            class="task_dialog">
            <div class="qrcode fx fx-center" ref="form1" id="qrcode"></div>
        </el-dialog>
        <div class="panel_foot fx fx-m_end fx-c_center">
            <el-pagination :background="true" prev-text="上一页" next-text="下一页" layout="prev, pager, next"
                :current-page="pager.currentPage" :page-size="pager.pageSize" :total="pager.dataTotal"
                @current-change="pageChange">
            </el-pagination>
        </div>
    </div>
</template>

<style>
    .task_dialog>>>.el-dialog {
        border-radius: 16px;
        overflow: hidden;
    }

    .qrcode img {
        margin-left: 15px;
    }
</style>
<script>
    import {
        mapState,
        mapMutations
    } from "vuex";
    import QRCode from 'qrcodejs2';
    export default {
        components: {},
        props: [
            "attr"
        ],
        data() {
            return {
                showEdit: false,
                form: {
                    keywords: "",
                    enable: null,
                },
                isPrivate: null,
                isOpenSource: null,
                subjectId: this.attr == undefined ? '' : this.attr.item,
                lessonTypes: [],
                pager: {
                    pageSize: 12,
                    dataTotal: 0,
                    currentPage: 1
                },
                tableData: [],
                dialogTableVisible: false,
                form1d: 1,
                url: "",
                form1: 0
            }

        },

        watch: {
            "form": {
                handler: function(newValue) {
                    this.pager.currentPage = 1;
                    this.loadData();
                },
                deep: true

            },
            isPrivate: function() {
                this.pager.currentPage = 1;
                this.loadData();
            },
            isOpenSource: function() {
                this.pager.currentPage = 1;
                this.loadData();
            },
        },

        methods: {
            share(item) {
                this.dialogTableVisible = true;
                this.$nextTick(() => {
                    document.getElementById("qrcode").innerHTML = "";
                    var qrcode = new QRCode(this.$refs.form1, {
                        text: this.url + '/program/mobileWork?id=' + item.id + '&mode=workview',
                        width: 300,
                        height: 300,
                        render: 'canvas',
                        colorDark: '#000000',
                        colorLight: '#ffffff',
                        correctLevel: QRCode.CorrectLevel.H
                    })
                })
            },
            view(item) {
                this.$goEditCode(item.lessonType, `mode=workview&id=${item.id}&${item.lessonType==4?'jr=':''}`);
            },
            detail(item) {
                if (item.lessonType == 2 || item.lessonType == 3) {
                    this.$goEditCode(item.lessonType, `mode=workview&id=${item.id}&${item.lessonType==4?'jr=':''}`);
                } else {
                    window.openTab("/program/work?isFromPub=false&mode=workview&id=" + item.id);
                }
            },

            modifyPrivate(item) {
                this.$ajaxGet("/work/togglePrivate/" + item.id + "-" + !item.isPrivate, data => {
                    item.isPrivate = !item.isPrivate;
                });
            },
            modifyOpenSource(item) {
                this.$ajaxGet("/work/toggleOpenSource/" + item.id + "-" + !item.isOpenSource, data => {
                    item.isOpenSource = !item.isOpenSource;
                });
            },

            loadData() {
                this.$ajaxPost("/work/list", {
                    form: this.form,
                    isPrivate: this.isPrivate,
                    isOpenSource: this.isOpenSource,
                    subjectId: this.subjectId,
                    pager: {
                        ...this.pager,
                        dataTotal: 0
                    }
                }, (data) => {
                    //分页不能带offset，否则会影响后台计算最新offset
                    let {
                        offset,
                        ...pager
                    } = data.pager;
                    this.pager = pager;
                    this.tableData = data.result;
                })
            },
            pageChange(page) {
                this.pager.currentPage = page;
                this.loadData();
            },
            loadLessonTypes() {
                this.$ajaxGet("/common/lessonType", (data) => {
                    this.lessonTypes = data.result;
                })
            },
            del(item) {
                this.$ajaxGet("/work/del/" + item.id, data => {
                    this.loadData();
                })
            }

        },

        created() {
            let url = window.location.origin;
            this.url = url;
            this.loadData();
            this.loadLessonTypes();
        }

    }
</script>
